<template>
    <div class="erm_books_wrapper">
        <SideNavBar :routes="routes" />
        <div class="erm_books_content_wrapper">
            <div class="erm_flex" style="justify-content: space-between">
                <div class="erm_left_navbar">
                    <h2>{{ pageTitle }}</h2>
                </div>
                <div class="erm_right_navbar">
                    <el-button @click="saveSettings()" type="primary">Save Settings</el-button>
                </div>
            </div>
            <router-view :settings="settings"></router-view>
        </div>
    </div>

</template>
<script>
import axios from 'axios';
import SideNavBar from '../../components/SideNavBar.vue';

export default {
    components: {
        SideNavBar
    },
    data() {
        return {
            loading: false,
            route: this.$route,
            mode: 'settings',
            rest_api: window.RestaurantMenuMangeData.rest_api,
            nonce: window.RestaurantMenuMangeData.nonce,
            settings: {},
            routes: [
                {
                    label: 'General',
                    to: '/settings'
                },
                {
                    label: 'Template',
                    to: '/settings/template-settings'
                },
                {
                    label: 'Reservation',
                    to: '/settings/reservation-settings'
                },
            ]
        }
    },
    watch: {
        '$route.path': {
            handler() {
                this.getSettings();
            },
            immediate: true // Call API when component is first mounted
        }
    },
    computed: {
        pageTitle() {
            return this.$route?.meta?.title || 'Default Title';
        },
        requiresAuth() {
            return this.$route.meta.requiresAuth || false;
        }
    },
    methods: {
        async getSettings() {
            console.log(this.$route)
            this.loading = true;
            try {
                const response = await axios.get(`${this.rest_api}/${this.$route?.meta?.key}`, {
                    headers: {
                        'X-WP-Nonce': this.nonce
                    }
                });
                this.settings = response.data?.color_data;
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.error('Error fetching settings',);
            }
        },

        async saveSettings() {
            try {
                const response = await axios.post(`${this.rest_api}/${this.$route?.meta?.key}`, {
                    settings: this.settings
                }, {
                    headers: {
                        'X-WP-Nonce': this.nonce
                    }
                });
                console.log('Color:', response.data);
            } catch (error) {
                console.error('Error fetching color:', error);
            }
        },
    }
}
</script>